/* Start svg4everybody for SVG sprite support in IE11 if available */
if (typeof svg4everybody === "function") {
  svg4everybody();
}
